import React from 'react';
import { Link } from 'react-router-dom';
import './NavigationForm.less';
import { Banner, Logo } from './../../../resources/images/index';
import { Row, Col, Menu } from 'antd';

const SubMenu = Menu.SubMenu;

class NavigationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logoCollapsed: false,
      selectedKeys: [''],
    };
  }

  /**
   * Add event listener based on window resize
   */
  componentDidMount() {
    this.handleSetCollapsed();
    window.addEventListener('resize', this.handleSetCollapsed);
  }

  /**
   * Remove event listeners
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleSetCollapsed);
  }

  /**
   * Sets header view based on window size to collapsed or expanded.
   */
  handleSetCollapsed = () => {
    if (window.innerHeight < 200 && !this.state.logoCollapsed) {
      this.setState({
        logoCollapsed: true,
      });
    }

    if (window.innerHeight >= 200 && this.state.logoCollapsed) {
      this.setState({
        logoCollapsed: false,
      });
    }

    if (window.innerWidth < 820 && !this.state.logoCollapsed) {
      this.setState({
        logoCollapsed: true,
      });
    }

    if (window.innerWidth >= 820 && this.state.logoCollapsed) {
      this.setState({
        logoCollapsed: false,
      });
    }
  };

  /**
   * Resets all selected menu keys
   * */
  handleLogoClick = () => {
    this.setState({ selectedKeys: [''] });
  };

  /**
   * Sets current selected menu key.
   * @param e is menu object
   */
  handleMenuClick = (e) => {
    this.setState({
      selectedKeys: [e.key],
    });
  };

  render() {
    return (
      <Row type={'flex'} align={'middle'} className={'navigation-form'}>
        <Col xs={12} sm={14} md={16} lg={18} xl={20}>
          <Link to={'/'} className={'float-left'} onClick={this.handleLogoClick}>
            <div className={'div-logo'}>
              {this.state.logoCollapsed ? (
                <img src={Logo} alt='Logo' />
              ) : (
                <img src={Banner} alt='Logo' />
              )}
            </div>
          </Link>
        </Col>
        <Col xs={6} sm={5} md={4} lg={3} xl={2}>
          {this.props.isAuthenticated && (
            <Menu
              className={'float-right'}
              mode={'horizontal'}
              theme={'dark'}
              selectedKeys={this.state.selectedKeys}
              onClick={this.handleMenuClick}
              subMenuOpenDelay={0.15}
            >
              <Menu.Item key={'history'}>
                <Link to={'/history'}></Link>Historik
              </Menu.Item>
              {this.props.isAdmin ? (
                <>
                  {/* Required minium width to not have submenu 'collapse'. */}
                  <SubMenu
                    style={{ minWidth: '82px' }}
                    title={<span className={'submenu-title-wrapper'}>Admin</span>}
                  >
                    <Menu.Item key={'userSettings'}>
                      <Link to={'/users'}></Link>Brugerindstillinger
                    </Menu.Item>
                    <Menu.Item key={'companySettings'}>
                      <Link to={'/companies'}></Link>Virksomhedsindstillinger
                    </Menu.Item>
                  </SubMenu>
                </>
              ) : (
                <>
                  {/* Required minium width to not have submenu 'collapse'. */}
                  <SubMenu
                    style={{ minWidth: '82px' }}
                    title={<span className={'submenu-title-wrapper'}>Bruger</span>}
                  >
                    <Menu.Item key={'userSettings'}>
                      <Link to={'/users'}></Link>Brugerindstillinger
                    </Menu.Item>
                  </SubMenu>
                </>
              )}
            </Menu>
          )}
        </Col>
        <Col xs={6} sm={5} md={4} lg={3} xl={2}>
          {this.props.isAuthenticated && (
            <Link className={'header-menu-link float-right'} to={'/logout'}>
              Log ud
            </Link>
          )}
        </Col>
      </Row>
    );
  }
}

export default NavigationForm;
